/* storybook-check-ignore */
import { Flex, Text } from '@opendoor/bricks/core';
import LightningIcon from 'components/exclusives/icons/LightningIcon';
import { OpenHouse } from 'declarations/exclusives/exclusiveListingInfo';
import moment from 'moment-timezone';
import {
  DEFAULT_TIMEZONE,
  ExclusiveTourRequestTimeSlot,
  SLOT_DATE_TIME_FORMAT,
  SLOT_TIME_FORMAT,
} from './util';
import { useMemo } from 'react';
import { Listing } from 'declarations/exclusives/listing';

export type ReserveATourSlotContentProps =
  | {
      slot?: undefined;
      isPrimary: boolean;
    }
  | {
      slot: ExclusiveTourRequestTimeSlot;
      slotExists: boolean;
    };

export default function ReserveATourSlotContent(
  props: ReserveATourSlotContentProps & { listing: Listing },
) {
  return (
    <Flex flexDirection="row" gridGap="1.25rem">
      <Flex
        display={['none', 'none', 'flex']}
        height="2.5rem"
        width="2.5rem"
        alignItems="center"
        justifyContent="center"
        borderRadius="roundedSquare"
        background="neutrals20"
        mt="0.25rem"
        mb="0.375rem"
      >
        <CalendarIcon />
      </Flex>
      {props.slot ? (
        <Flex flexDirection="column">
          <SpotTime slot={props.slot} timezone={props.listing.timezone} />
          {props.slotExists ? (
            <Text
              as="div"
              color="neutrals90"
              fontSize="s1"
              lineHeight="s00"
              display="flex"
              alignItems="center"
              gridGap="0.25rem"
              textAlign="left"
            >
              Limited slots left · <LightningIcon color="var(--colors-green50)" />
              <Text as="span" color={'green50'}>
                Instant
              </Text>
            </Text>
          ) : (
            <Text color="neutrals90" fontSize="s1" lineHeight="s00" textAlign="left">
              Preferred{' '}
              <Text as="span" display={['none', 'none', 'block-inline']}>
                time
              </Text>
            </Text>
          )}
        </Flex>
      ) : (
        <Flex flexDirection="column">
          <Text color="neutrals100" fontWeight="semibold" fontSize="s1" textAlign="left">
            Request new time
          </Text>
          <Text color="neutrals90" fontSize="s1" lineHeight="s00" textAlign="left">
            Be the first to tour
          </Text>
        </Flex>
      )}
    </Flex>
  );
}

function CalendarIcon() {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.75 2C6.75 1.30964 6.19036 0.75 5.5 0.75C4.80964 0.75 4.25 1.30964 4.25 2V4H3C1.34315 4 0 5.34315 0 7V18C0 19.6569 1.34315 21 3 21H17C18.6569 21 20 19.6569 20 18V7C20 5.34315 18.6569 4 17 4H15.75V2C15.75 1.30964 15.1904 0.75 14.5 0.75C13.8096 0.75 13.25 1.30964 13.25 2V4H6.75V2ZM4.25 6.5V7.5C4.25 8.19036 4.80964 8.75 5.5 8.75C6.19036 8.75 6.75 8.19036 6.75 7.5V6.5H13.25V7.5C13.25 8.19036 13.8096 8.75 14.5 8.75C15.1904 8.75 15.75 8.19036 15.75 7.5V6.5H17C17.2761 6.5 17.5 6.72386 17.5 7V9.75H2.5V7C2.5 6.72386 2.72386 6.5 3 6.5H4.25ZM2.5 18V12.25H17.5V18C17.5 18.2761 17.2761 18.5 17 18.5H3C2.72386 18.5 2.5 18.2761 2.5 18Z"
        fill="#222222"
      />
    </svg>
  );
}

function SpotTime({ slot, timezone = DEFAULT_TIMEZONE }: { slot: OpenHouse; timezone?: string }) {
  const { startTime, endTime } = useMemo(() => {
    return {
      startTime: moment(slot.start_time).tz(timezone),
      endTime: moment(slot.end_time).tz(timezone),
    };
  }, [slot]);
  return (
    <Text color="neutrals100" fontWeight="semibold" fontSize="s1" textAlign="left">
      {startTime.format(SLOT_DATE_TIME_FORMAT)} - {endTime.format(SLOT_TIME_FORMAT)}
    </Text>
  );
}
